var map = {
	"./404.svg": 94235,
	"./Analytics.svg": 23531,
	"./PepiconsAirplane.svg": 69104,
	"./PepiconsCircle.svg": 17598,
	"./PepiconsCircleFilled.svg": 13178,
	"./airPlane.svg": 8999,
	"./asideClosed.svg": 76815,
	"./asideOpened.svg": 50992,
	"./cascader.svg": 16449,
	"./checkbox.svg": 75742,
	"./clipboard.svg": 96889,
	"./code.svg": 37478,
	"./color.svg": 54958,
	"./component.svg": 10250,
	"./dashboard.svg": 4679,
	"./date-range.svg": 47913,
	"./date.svg": 84213,
	"./dict.svg": 21009,
	"./documentation.svg": 23397,
	"./download.svg": 15253,
	"./drag.svg": 28715,
	"./edit.svg": 95869,
	"./email.svg": 39083,
	"./excel.svg": 42474,
	"./exit-fullscreen.svg": 54861,
	"./eye-close.svg": 46499,
	"./eye-open.svg": 12429,
	"./form.svg": 3771,
	"./fullscreen.svg": 6638,
	"./guide.svg": 47987,
	"./international.svg": 5091,
	"./job.svg": 76630,
	"./link.svg": 81445,
	"./list.svg": 99161,
	"./lock.svg": 52636,
	"./menu-icon-expand.svg": 85387,
	"./menu-icon_collapse.svg": 38580,
	"./menu.svg": 88804,
	"./monitor.svg": 78737,
	"./nested.svg": 85016,
	"./online.svg": 96196,
	"./order.svg": 80431,
	"./orderedList.svg": 84356,
	"./password.svg": 39902,
	"./peoples.svg": 46779,
	"./phone.svg": 37755,
	"./question.svg": 5269,
	"./search.svg": 58217,
	"./select.svg": 93441,
	"./swagger.svg": 85215,
	"./switch.svg": 69377,
	"./system.svg": 14518,
	"./tab.svg": 94598,
	"./table.svg": 54383,
	"./tagsFilled.svg": 50054,
	"./time-range.svg": 57038,
	"./time.svg": 61830,
	"./tool.svg": 36663,
	"./tree-table.svg": 41622,
	"./tree.svg": 92701,
	"./upload.svg": 29538,
	"./user.svg": 68848,
	"./validCode.svg": 28538
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;